import { Leaf, Users, Zap, Clock } from "lucide-react";

const features = [
  {
    icon: Leaf,
    title: "Fully Insured",
    description:
      "Complete liability coverage for your peace of mind. Every job is done professionally and safely.",
  },
  {
    icon: Users,
    title: "Local Minnesota Experts",
    description:
      "We know Minnesota lawns and what they need to thrive through every season.",
  },
  {
    icon: Zap,
    title: "Quality Equipment",
    description:
      "Professional-grade equipment and premium products ensure your lawn looks its absolute best.",
  },
  {
    icon: Clock,
    title: "On-Time & Reliable",
    description:
      "Clear communication, honest pricing, and services completed on schedule. No surprises.",
  },
];

export const Features = () => {
  return (
    <section className="py-20" aria-labelledby="features-heading">
      <div className="container mx-auto px-4">
        <h2 id="features-heading" className="sr-only">Why Choose Riekels Lawn Care</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <article key={index} className="feature-card">
              <div className="icon-circle mb-4" aria-hidden="true">
                <feature.icon className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-heading font-bold text-foreground mb-3">
                {feature.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
